import React, {Component} from "react";
import Cookies from "js-cookie";
import axios from "axios";
import TagManager from "react-gtm-module";
import "./App.scss";
import "./assets/scss/main.scss";
import * as Styled from "./CSSStyles";
import {HashRouter as Router, Switch, Route, Link, Redirect} from "react-router-dom";
import Bag from "./pages/Bag";
import Confirm from "./pages/Confirm";
import ThankYou from "./pages/ThankYou";
import CheckoutPageError from "./components/CheckoutPageError/CheckoutPageError";
import PageDoesntExist from "./pages/404";
import GlobalNav from "./components/GlobalNav/GlobalNav";
import GlobalFooter from "./components/GlobalFooter/GlobalFooter";

const gtmId = "GTM-MXMG453";

class App extends Component {
  constructor(props) {
    super(props);
    this.bagDeleteModalRef = React.createRef();

    this.state = {
      bagPagePath: "/bag",
      checkoutPagePath: "/order-details",
      thankyouPagePath: "/thank-you",
      customerIsLoggedIn:
        setTimeout(function () {
          Cookies.get("isLoggedIn");
        }, 1000) || 0,
      customerSession: Cookies.get("KK_SESSION_ID"),
      customerIsGuest: Cookies.get("KK_IS_GUEST"),
      customerId: Cookies.get("KK_CUSTOMER_ID"),
      customerEmail: Cookies.get("kkUserEmail"),
      getBagAPIURL: "/api/checkout/bag",
      profileAPIURL: "/api/checkout/profile",
      // profileAPIURL: "../test_data/profile.json",
      // getBagAPIURL: "../test_data/bag.json",
      // customerId: 1234567,
      // customerEmail: "email@email.com",
      removeBagAPIURL: "/api/checkout/remove-bag-item",
      updateBagAPIURL: "/api/checkout/update-bag-item",
      updateMiniCartAPIURL: "/api/checkout/clear-mini-cart",
      referrer: document.referrer,
      isUserRegistered: false,
      continueShoppingUrl: "",
      signInLink: "",
      registerLink: "",
      guestCheckoutLink: "",
      signinAndCheckoutLink: "",
      profile: [],
      cart: [],
      shipping: [],
      profileId: 0,
      profileLastName: "",
      profileEmail: "",
      orderSubTotal: 0,
      BagItemCount: 0,
      currency: "",
      bagSummaryFixed: "",
      isRemoveModalOpen: "",
      getItemISBN: "",
      isDeleteAddressModalOpen: "",
      addressDeleteId: "",
      saveAsSelectedAddress: false,
      shippingId: 0,
      shippingType: "",
      shippingPrice: "",
      shippingPerItem: "",
      shippingTotal: "",
      shippingDeliverBy: "",
      countryFocus: "",
      stateZoneFocus: "",
      initialAddress: "",
      initialBilling: "",
      orderSummary: [],
      orderSummarySubTotal: 0,
      orderSummaryTotal: 0,
      orderSummaryPreorderTotal: 0,
      orderSummaryVat: 0,
      bagLoader: false,
      profileLoader: false,
      bagEmpty: false,
      bagAPIErrors: "",
      bagAPIErrorMessage: "",
      bagAPIErrorHTML: "",
      checkoutLink: "/",
      discountCode: "",
      isBagUpdated: false,
      confirmRedirect: false,
      isCartEmpty: false,
      getBagError: false,
      isAdmin: false,
      isGuestCheckoutBlank: false,
      profileError: "",
      updateQtyAction: "",
      updateISBN: "",
      updateTitle: "",
      updatePrice: "",
      updateBrand: "",
      updateCategoryOld: "",
      updateCategory: "",
      updateCategory2: "",
      updateCategory3: "",
      updateCategory4: "",
      updateCategory5: "",
      updateType: "",
      updateQty: "",
      updateCurrency: "",
      updateDiscountedPrice: "",
      updateIndex: "",
      deleteTitle: "",
      deleteISBN: "",
      deletePrice: "",
      deleteBrand: "",
      deleteCategoryOld: "",
      deleteCategory: "",
      deleteCategory2: "",
      deleteCategory3: "",
      deleteCategory4: "",
      deleteCategory5: "",
      deleteType: "",
      deleteQty: "",
      deleteCurrency: "",
      deleteDiscountedPrice: "",
      deleteIndex: "",
      gtm_products: [],
      checkout_gtm_fireonce: false,
      begin_checkout_gtm_fireonce: false,
      currentPage: "",
      isSigninModalOpen: "",
      accessibilityInput: "",
      cameFromBagPage: false,
      cartMessageDigitalResourceList: [],
      cartMessageSecondHandIsbnList: [],
      cartMessageDigitalAccessCodeList: [],
      cartMessageFamilyNames: [],
      isCartCustomMessage: false,
      isAuRegion: false,
      hidePromoFieldBag: false,
    };
  }

  listenScrollEvent = () => {
    if (window.scrollY > 167.88) {
      this.setState({bagSummaryFixed: "bag-summary-fixed"});
    } else {
      this.setState({bagSummaryFixed: ""});
    }
  };
  componentDidUpdate = () => {
    if (this.state.bagLoader) {
      document.body.classList.add("bagLoader-open");
    }
    if (!this.state.bagLoader) {
      document.body.classList.remove("bagLoader-open");
    }
  };
  componentDidMount() {
    // If there is no user session on page load, clear kkUserEmail cookie
    if (!Cookies.get("KK_SESSION_ID")) {
      Cookies.remove("kkUserEmail");
    }

    // -- Start Google Tag Manager -- //
    const tagManagerArgs = {
      gtmId: gtmId,
    };

    TagManager.initialize(tagManagerArgs);
    // -- End Google Tag Manager -- //

    // Remove 'customRedirect' cookie on page load
    Cookies.remove("customRedirect");

    this.setState({
      confirmRedirect: localStorage.getItem("confirmRedirect"),
    });

    const custId = this.state.customerId;
    if (custId != null && custId > 0) {
      // registered
      this.setState({
        isUserRegistered: true,
      });
    }
    this.getProfileAPI();
    window.addEventListener("scroll", this.listenScrollEvent);
  }

  getBagAPI = (e) => {
    let tempItemCount = 0;
    let currency;
    let storageReferrer = this.getReferrer();
    
    this.setState({bagLoader: true, getBagError: false}, () => {
      axios
        .get(this.state.getBagAPIURL, {
          params: {
            referrer: storageReferrer,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          const items = response.data.bag;
          const updatedItems = items.map((item) => {
            return {
              ...item,
              tempQuantity: item.quantity,
              tempTotalPrice: item.totalPrice,
              currency: item.currency,
            };
          });
          // Update minibag count from localStorage. 
          if (items.length > 0) {
            const totalQuantity = updatedItems.map(item => item.quantity).reduce((prev, next) => prev + next);
            if (totalQuantity) {
              localStorage.setItem("MINIBAG_COUNT", totalQuantity);
            }
          } else {
            localStorage.removeItem("MINIBAG_COUNT");
          }
          const orderSummary = response.data.OrderSummary;
          const updatedOrderSummary = orderSummary.map((summary) => {
            return summary.subTotal;
          });
          const checkoutLink = response.data.checkoutLink;
          const hidePromoFieldBag = response.data.hidePromoField;
          let discountCode = "";

          discountCode = response.data.discountCode;
          this.setState(
            {
              cart: updatedItems,
              orderSummaryTotal: updatedOrderSummary,
              checkoutLink: checkoutLink,
              hidePromoFieldBag: hidePromoFieldBag,
              isBagUpdated: e == "updatedFromConfirm",
              discountCode: discountCode,
              customerIsLoggedIn:
                setTimeout(function () {
                  Cookies.get("isLoggedIn");
                }, 1000) || 0,
            },
            () => {
              // GTM
              if (!this.state.checkout_gtm_fireonce && (window.location.href.indexOf("bag") > -1)) {
                this.triggerGTM("checkout_bagPage"); //trigger onload gtm
                this.setState({checkout_gtm_fireonce: true});
              }
              // Cart
              this.state.cart.forEach((item) => {
                tempItemCount = tempItemCount + parseInt(item.tempQuantity);
                currency = item.currency;
              });
              this.setState(
                {
                  BagItemCount: tempItemCount,
                  currency: currency,
                  isBagUpdated: false,
                  bagLoader: false,
                },
                () => {
                  if (this.state.BagItemCount == 0) {
                    this.setState({
                      bagEmpty: true,
                    });
                    window.location.href = "./#" + this.state.bagPagePath;
                  }
                }
              );
              // Cart message
              this.setState(
                {
                  cartMessageDigitalResourceList: [],
                  cartMessageSecondHandIsbnList: [],
                  cartMessageDigitalAccessCodeList: [],
                  cartMessageFamilyNames: [],
                  isCartCustomMessage: false,
                  isAuRegion: false,
                },
                () => {
                  this.state.cart.forEach((cartItem) => {
                    if ('cartMessage' in cartItem) {
                      this.setState({isAuRegion: true});
                    }
                    else{
                      this.setState({isAuRegion: false});
                    }
                    if (cartItem.cartMessage) {
                      if (cartItem.cartMessage.hasDigitalResource) {
                        this.setState(
                          (prevState) => ({
                            cartMessageDigitalResourceList: [...prevState.cartMessageDigitalResourceList, cartItem.title],
                          }),
                          () => {
                            this.validateCartMessage();
                          }
                        );
                      }
                      if (cartItem.cartMessage.secondHandIsbn) {
                        this.setState(
                          (prevState) => ({
                            cartMessageSecondHandIsbnList: [
                              ...prevState.cartMessageSecondHandIsbnList,
                              {
                                cartItemTitle: cartItem.title,
                                familyName: cartItem.cartMessage.familyName,
                                secondHandIsbn: cartItem.cartMessage.secondHandIsbn,
                                secondHandIsbnCover: cartItem.cartMessage.secondHandIsbnCover,
                              },
                            ],
                          }),
                          () => {
                            this.validateCartMessage();
                          }
                        );
                      }
                      if (cartItem.cartMessage.isDigitalAccess) {
                        this.setState(
                          (prevState) => ({
                            cartMessageDigitalAccessCodeList: [...prevState.cartMessageDigitalAccessCodeList, cartItem.title],
                          }),
                          () => {
                            this.validateCartMessage();
                          }
                        );
                      }
                      if (cartItem.cartMessage.familyName) {
                        if (!this.state.cartMessageFamilyNames.includes(cartItem.cartMessage.familyName)) {
                          this.state.cartMessageFamilyNames.push(cartItem.cartMessage.familyName);
                          this.validateCartMessage();
                        }
                      }
                    }
                  });
                  window.scrollTo(0, 0);
                }
              );
            }
          );
        })
        .catch((error) => {
          if (error.response) {
            const errorCode = error.response.status;
            const errorText = "Error " + errorCode + ". Bag not loaded.";
            const errorMessage = "Bag details not loaded.";
            const errorHTML = error.response.data;

            this.setState({
              bagLoader: false,
              getBagError: true,
              bagAPIErrorCode: errorCode,
              bagAPIErrors: errorText,
              bagAPIErrorMessage: errorMessage,
              bagAPIErrorHTML: errorHTML,
              cart: [],
            });
          }
        });
    });
  };
  validateCartMessage = () => {
    if (
      (this.state.cartMessageDigitalAccessCodeList && this.state.cartMessageDigitalAccessCodeList.length > 0) ||
      (this.state.cartMessageSecondHandIsbnList && this.state.cartMessageSecondHandIsbnList.length > 0) ||
      (this.state.cartMessageDigitalResourceList && this.state.cartMessageDigitalResourceList.length > 0)
    ) {
      this.setState({isCartCustomMessage: true});
    } else {
      this.setState({isCartCustomMessage: false});
    }
  };
  deleteCartApi = (isbnNumber) => {
    this.setState({
      bagLoader: true,
    },()=>{
      axios
        .delete(this.state.removeBagAPIURL, {params: {isbn: isbnNumber}})
        .then((response) => {
          this.setState({
            bagLoader: false,
          },()=>{
            this.triggerGTM("removeFromCart");
            this.updateMiniCartApi();
            this.getBagAPI();
            this.getProfileAPI(); //reload profile API when Bag updated
            this.clearErrorCodes();
          });
        })
        .catch((error) => {
          if (error.response) {
            const errorCode = error.response.status;
            const errorText = "Error " + errorCode + ". ISBN " + isbnNumber + " not deleted. Please try again.";
            const errorMessage = "Item not deleted. Please try again.";
            const errorHTML = error.response.data;
  
            this.setState({
              bagAPIErrorCode: errorCode,
              bagLoader: false,
              bagAPIErrors: errorText,
              bagAPIErrorMessage: errorMessage,
              cart: [],
            });
          }
        });
      });
  };
  updateCartQuantityApi = (isbnNumber, quantity) => {
    this.setState({bagLoader: true}, () => {
      axios
        .put(this.state.updateBagAPIURL, null, {
          params: {
            isbn: isbnNumber,
            qty: quantity,
          },
        })
        .then((response) => {
          this.triggerGTM("updateCartQty");
          this.updateMiniCartApi();
          this.getBagAPI();
          this.clearErrorCodes();
        })
        .catch((error) => {
          if (error.response) {
            const errorCode = error.response.status;
            const errorText = "Error " + errorCode + ". ISBN " + isbnNumber + " quantity not updated. Please try again.";
            const errorMessage = "Bag quantity not updated. Please try again.";
            const errorHTML = error.response.data;

            this.setState({
              bagAPIErrorCode: errorCode,
              bagLoader: false,
              bagAPIErrors: errorText,
              bagAPIErrorMessage: errorMessage,
              cart: [],
            });
          }
        });
    });
  };
  updateMiniCartApi = () => {
    axios
      .post(this.state.updateMiniCartAPIURL)
      .then((response) => {})
      .catch((error) => {
        this.setState({bagLoader: false});
      });
  };
  getProfileAPI = () => {
    let storageReferrer = this.getReferrer();

    this.setState({profileLoader: true}, () => {
      axios
        .get(this.state.profileAPIURL, {
          params: {
            referrer: storageReferrer,
          },
        })
        .then((response) => {
          this.setState(
            {
              continueShoppingUrl: response.data.path.referrer,
              signInLink: response.data.path.signInLink,
              registerLink: response.data.path.registerLink,
              guestCheckoutLink: response.data.path.guestCheckoutLink,
              signinAndCheckoutLink: response.data.path.signinAndCheckoutLink,
              isRedirectPaymentOptions: response.data.path.guestCheckoutLink.indexOf("/payment_options") >= 0,
              isAdmin: false,
              isGuestCheckoutBlank: response.data.path.guestCheckoutLink == "",
              profileError: response.data.error,
            },
            () => {
              this.setState({profileLoader: false}, () => {
                if (this.state.guestCheckoutLink == "") {
                  this.goToBag();
                }
              });
            }
          );
        })
        .catch((error) => {
          this.setState({profileLoader: false});
        });
    });
  };

  getReferrer = () => {
    const prevPage = document.referrer;
    let storageReferrer = "";
    if (prevPage && !prevPage.includes("/checkout")) {
      storageReferrer = prevPage;
      localStorage.setItem("previousPage", prevPage);
    } else {
      storageReferrer = localStorage.getItem("previousPage");
    }
    return storageReferrer;
  }

  changeQuantityHandler = (event, isbn, title, price, brand, category, subject, learningStage, qualification, series, type, quantity, currency, discountedPrice, index) => {
    const counter = parseInt(event.target.value);
    const computedQty = quantity > counter ? parseInt(quantity) - parseInt(counter) : parseInt(counter) - parseInt(quantity);
    const gtmQtyAction = quantity > counter ? "removeFromCart" : "addToCart";

    this.setState(
      {
        updateQtyAction: gtmQtyAction,
        updateISBN: isbn,
        updateTitle: title,
        updatePrice: price,
        updateBrand: brand,
        updateCategoryOld: category,
        updateCategory: subject,
        updateCategory2: learningStage,
        updateCategory3: qualification,
        updateCategory4: type,
        updateCategory5: series,
        updateType: type,
        updateQty: computedQty,
        updateCurrency: currency,
        updateDiscountedPrice: discountedPrice,
        updateIndex: index,
      },
      () => {
        this.updateCartQuantityApi(isbn, counter);
      }
    );
  };

  showConfirmModalHandler = (event, page, id, itemTitle, itemPrice, itemBrand, itemCategory, itemSubject, itemLearningStage, itemQualification, itemSeries, itemType, itemQty, itemCurrency, itemDiscountedPrice, index) => {
    this.setState(
      {
        isRemoveModalOpen: "isOpen",
        getItemISBN: id,
        deleteISBN: id,
        deleteTitle: itemTitle,
        deletePrice: itemPrice,
        deleteBrand: itemBrand,
        deleteCategoryOld: itemCategory,
        deleteCategory: itemSubject,
        deleteCategory2: itemLearningStage,
        deleteCategory3: itemQualification,
        deleteCategory4: itemType,
        deleteCategory5: itemSeries,
        deleteType: itemType,
        deleteQty: itemQty,
        deleteCurrency: itemCurrency,
        deleteDiscountedPrice: itemDiscountedPrice,
        deleteIndex: index,
      },
      () => {
        this.bagDeleteModalRef.current.focus();
      }
    );
  };
  deleteItemHandler = (event) => {
    // Delete item from cart function goes here
    const isbn = this.state.getItemISBN;
    this.deleteCartApi(isbn);
    this.closeConfirmModalHandler();
  };
  closeConfirmModalHandler = (event) => {
    this.setState({
      isRemoveModalOpen: "",
    });
  };

  saveAsSelectedAddressHandler = (checked) => {
    this.setState(
      {
        ...this.state.saveAsSelectedAddress,
        saveAsSelectedAddress: !this.state.saveAsSelectedAddress,
      },
      () => {}
    );
  };
  confirmItemsEmpty = () => {
    this.setState({isCartEmpty: true});
  };
  guestCustomerId = (e) => {
    this.setState({customerId: e}, () => {
      if (this.state.customerId && this.state.customerId > 0) {
        this.setState({
          isUserRegistered: true,
        });
      }
    });
  };
  refreshPage = () => {
    window.location.reload();
    return false;
  };
  goToBag = () => {
    if (window.location.href.indexOf(this.state.checkoutPagePath) > -1 || window.location.href.indexOf(this.state.thankyouPagePath) > -1) {
      window.location.href = "./";
    }
  };
  isGuestCheckoutBlank = () => {
    return this.state.isGuestCheckoutBlank;
  };
  clearErrorCodes = () => {
    this.setState({
      bagAPIErrorCode: "",
      bagAPIErrors: "",
      bagAPIErrorMessage: "",
      bagAPIErrorHTML: "",
    });
  };
  triggerGTM = (action) => {
    if (window["google_tag_manager"] && window["google_tag_manager"][gtmId] && window["google_tag_manager"][gtmId].dataLayer) {
      window["google_tag_manager"][gtmId].dataLayer.reset();
    }

    switch (action) {
      case "checkout_bagPage": // ------------------- on load checkout page (bag api) ------------------- //
        Cookies.set("ITEM_LIST", this.state.currentPage);
        const checkout_products_b = this.state.cart;
        var currencyCode, stream;
        const bagItems = checkout_products_b.map((item, index) => {
          currencyCode = item.currencyCode;
          if (index == 0) {
            stream = item.gtm.brand;
          }
          return {
            item_id: item.isbn,                       // The ID of the item, in our case ISBN
            item_name: item.title,                    // The name of the item
            affiliation: "Cambridge", // A product affiliation to designate a supplying company or brick and mortar store location. In our case, Cambridge
            coupon: this.state.discountCode,          // The coupon name/code associated with the item.
            discount: item.discountedPrice ? (parseFloat(item.price - item.discountedPrice)) : 0.00, // The monetary discount value associated with the item.
            index: index,                             // The index/position of the item in a list.
            item_brand: item.gtm.brand,               // The brand of the item. In our case academic, education or cambridge english
            item_category: (typeof item.subject !== "undefined") ? item.subject : "", // Subject
            item_category2: (typeof item.learningStage !== "undefined") ? item.learningStage : "", // Learning Stage
            item_category3: (typeof item.qualification !== "undefined") ? item.qualification : "", // Qualification
            item_category4: (typeof item.type !== "undefined") ? item.type : "", // Format
            item_category5: (typeof item.series !== "undefined") ? item.series : "", // Series Name
            item_list_id: "",                         // The ID of the list in which the item was presented to the user. We may not be using this.
            item_list_name: this.state.currentPage,   // The name of the list in which the item was presented to the user. In this case Bag List
            item_variant: item.gtm.variant,           // The item variant or unique code or description for additional item details/options.
            location_id: "",                          // The physical location associated with the item (e.g. the physical store location) NA
            price: parseFloat(item.price),                        // The monetary price of the item, in units of the specified currency parameter.
            quantity: item.quantity,                  // Item quantity.
          };
        });
        this.setState(
          {
            gtm_products: bagItems,
          },
          () => {
            const tagManagerArgs_checkout_b = {
              gtmId: gtmId,
              dataLayer: {
                event: (window.location.href.indexOf("bag") > -1) ? "view_cart" : "begin_checkout", // name of an event. In this case, always stays as view_cart
                ecommerce: {                                  // ecommerce object. This is the essential part of tracking. New EE data must always be pushed to this object
                  currency: currencyCode,                     // Currency of the items associated with the event
                  value: parseFloat(this.state.orderSummaryTotal[0]),        // The monetary value of the event
                  items: bagItems,                            // The items for the event - this is an array
                },
                stream: stream
              },
            };

            TagManager.dataLayer(tagManagerArgs_checkout_b);
          }
        );
        break;
      case "updateCartQty":
        // ------------------- on item quantity update from bag ------------------- //

        const updateQty_list = this.state.currentPage;
        const updateQty_name = this.state.updateTitle;
        const updateQty_id = this.state.updateISBN;
        const updateQty_price = this.state.updatePrice;
        const updateQty_brand = this.state.updateBrand;
        const updateQty_category_old = this.state.updateCategoryOld;
        const updateQty_category = this.state.updateCategory;
        const updateQty_category2 = this.state.updateCategory2;
        const updateQty_category3 = this.state.updateCategory3;
        const updateQty_category4 = this.state.updateCategory4;
        const updateQty_category5 = this.state.updateCategory5;
        const updateQty_variant = this.state.updateType;
        const updateQty_quantity = this.state.updateQty;
        const updateQty_currency = this.state.updateCurrency;
        const updateQty_discountedPrice = this.state.updateDiscountedPrice;
        const updateQty_index = this.state.updateIndex;
        let tagManagerArgs_updateQty_GA3 = "";
        let tagManagerArgs_updateQty_GA4 = "";

        if (this.state.updateQtyAction == "addToCart") {
          // GA3 Add To Cart Using Dropdown
          tagManagerArgs_updateQty_GA3 = {
            gtmId: gtmId,
            dataLayer: {
              event: "addToCart", // name of an event. In this case, always stays as addToCart
              ecommerce: {
                // ecommerce object. This is the essential part of tracking. New EE data must always be pushed to this object
                currencyCode: updateQty_currency, // the currency which is currently used by a visitor
                add: {
                  // name of an action. In this case, always stays as add
                  actionField: {
                    list: updateQty_list, // optional. name of a list from which the product was added to a cart
                  },
                  products: [
                    {
                      // list of products added to a cart. Can contain multiple products at the same time
                      name: updateQty_name, // name of a product that was added to a cart
                      id: updateQty_id, // id of a product
                      price: updateQty_price, // price of a product
                      brand: updateQty_brand, // brand/vendor of a product
                      category: updateQty_category_old, // category of a product
                      variant: updateQty_variant, // product variant. If there are no variants, exclude this key from the dataLayer.push
                      quantity: updateQty_quantity,
                    },
                  ],
                },
              },
            },
          };

          // GA4 Add To Cart Using Dropdown
          tagManagerArgs_updateQty_GA4 = {
            gtmId: gtmId,
            dataLayer: {
              event: "add_to_cart",
              ecommerce: {
                items: [
                  {
                    item_id: updateQty_id,
                    item_name: updateQty_name,
                    affiliation: "Cambridge",
                    coupon: this.state.discountCode,
                    currency: updateQty_currency,
                    discount: updateQty_discountedPrice ? (parseFloat(updateQty_price - updateQty_discountedPrice)) : 0.00,
                    index: updateQty_index,
                    item_brand: updateQty_brand,
                    item_category: (typeof updateQty_category !== "undefined") ? updateQty_category : "",
                    item_category2: (typeof updateQty_category2 !== "undefined") ? updateQty_category2 : "",
                    item_category3: (typeof updateQty_category3 !== "undefined") ? updateQty_category3 : "",
                    item_category4: (typeof updateQty_category4 !== "undefined") ? updateQty_category4 : "",
                    item_category5: (typeof updateQty_category5 !== "undefined") ? updateQty_category5 : "",
                    item_list_id: "",
                    item_list_name: updateQty_list,
                    item_variant: updateQty_variant,
                    location_id: "",
                    price: parseFloat(updateQty_price),
                    quantity: updateQty_quantity
                  }
                ]
              }
            },
          };
        } else {
          // GA3 Remove From Cart Using Dropdown
          tagManagerArgs_updateQty_GA3 = {
            gtmId: gtmId,
            dataLayer: {
              event: "removeFromCart", // name of an event. In this case, always stays as removeFromCart
              ecommerce: {
                // ecommerce object. This is the essential part of tracking. New EE data must always be pushed to this object
                currencyCode: updateQty_currency, // the currency which is currently used by a visitor
                remove: {
                  // name of an action. In this case, always stays as remove
                  actionField: {
                    list: updateQty_list, // optional. name of a list from which the product was deleted from a cart
                  },
                  products: [
                    {
                      // list of products removed from a cart. can include multiple products.
                      name: updateQty_name, // name of a product that was removed from a cart
                      id: updateQty_id, // id of a product
                      price: updateQty_price, // price of a product
                      brand: updateQty_brand, // brand/vendor of a product
                      category: updateQty_category_old, // category of a product
                      variant: updateQty_variant, // product variant. If there are no variants, exclude this key from the dataLayer.push
                      quantity: updateQty_quantity,
                    },
                  ],
                },
              },
            },
          };

          // GA4 Remove From Cart Using Dropdown
          tagManagerArgs_updateQty_GA4 = {
            gtmId: gtmId,
            dataLayer: {
              event: "remove_from_cart",
              ecommerce: {
                items: [
                  {
                    item_id: updateQty_id,
                    item_name: updateQty_name,
                    affiliation: "Cambridge",
                    coupon: this.state.discountCode,
                    currency: updateQty_currency,
                    discount: updateQty_discountedPrice ? (parseFloat(updateQty_price - updateQty_discountedPrice)) : 0.00,
                    index: updateQty_index,
                    item_brand: updateQty_brand,
                    item_category: (typeof updateQty_category !== "undefined") ? updateQty_category : "",
                    item_category2: (typeof updateQty_category2 !== "undefined") ? updateQty_category2 : "",
                    item_category3: (typeof updateQty_category3 !== "undefined") ? updateQty_category3 : "",
                    item_category4: (typeof updateQty_category4 !== "undefined") ? updateQty_category4 : "",
                    item_category5: (typeof updateQty_category5 !== "undefined") ? updateQty_category5 : "",
                    item_list_id: "",
                    item_list_name: updateQty_list,
                    item_variant: updateQty_variant,
                    location_id: "",
                    price: parseFloat(updateQty_price),
                    quantity: updateQty_quantity
                  }
                ]
              }
            },
          };
        }

        // GA3 Data Layer Push
        TagManager.dataLayer(tagManagerArgs_updateQty_GA3);
        // GA4 Data Layer Push
        TagManager.dataLayer(tagManagerArgs_updateQty_GA4);
        break;
      case "removeFromCart":
        // ------------------- on delete item from bag ------------------- //

        const removeFromCart_list = this.state.currentPage;
        const removeFromCart_name = this.state.deleteTitle;
        const removeFromCart_id = this.state.deleteISBN;
        const removeFromCart_price = this.state.deletePrice;
        const removeFromCart_brand = this.state.deleteBrand;
        const removeFromCart_category_old = this.state.deleteCategoryOld;
        const removeFromCart_category = this.state.deleteCategory;
        const removeFromCart_category2 = this.state.deleteCategory2;
        const removeFromCart_category3 = this.state.deleteCategory3;
        const removeFromCart_category4 = this.state.deleteCategory4;
        const removeFromCart_category5 = this.state.deleteCategory5;
        const removeFromCart_variant = this.state.deleteType;
        const removeFromCart_quantity = this.state.deleteQty;
        const removeFromCart_currency = this.state.deleteCurrency;
        const removeFromCart_discountedPrice = this.state.deleteDiscountedPrice;
        const removeFromCart_index = this.state.deleteIndex;
        let tagManagerArgs_removeFromCart_GA3 = "";
        let tagManagerArgs_removeFromCart_GA4 = "";

        // GA3 Remove From Cart Using Trash Can Button
        tagManagerArgs_removeFromCart_GA3 = {
          gtmId: gtmId,
          dataLayer: {
            event: "removeFromCart", // name of an event. In this case, always stays as removeFromCart
            ecommerce: {
              // ecommerce object. This is the essential part of tracking. New EE data must always be pushed to this object
              currencyCode: removeFromCart_currency, // the currency which is currently used by a visitor
              remove: {
                // name of an action. In this case, always stays as remove
                actionField: {
                  list: removeFromCart_list, // optional. name of a list from which the product was deleted from a cart
                },
                products: [
                  {
                    // list of products removed from a cart. can include multiple products.
                    name: removeFromCart_name, // name of a product that was removed from a cart
                    id: removeFromCart_id, // id of a product
                    price: removeFromCart_price, // price of a product
                    brand: removeFromCart_brand, // brand/vendor of a product
                    category: removeFromCart_category_old, // category of a product
                    variant: removeFromCart_variant, // product variant. If there are no variants, exclude this key from the dataLayer.push
                    quantity: removeFromCart_quantity,
                  },
                ],
              },
            },
          },
        };

        // GA4 Remove From Cart Using Trash Can Button
        tagManagerArgs_removeFromCart_GA4 = {
          gtmId: gtmId,
          dataLayer: {
            event: "remove_from_cart",
            ecommerce: {
              items: [
                {
                  item_id: removeFromCart_id,
                  item_name: removeFromCart_name,
                  affiliation: "Cambridge",
                  coupon: this.state.discountCode,
                  currency: removeFromCart_currency,
                  discount: removeFromCart_discountedPrice ? (removeFromCart_price - removeFromCart_discountedPrice) : 0.00,
                  index: removeFromCart_index,
                  item_brand: removeFromCart_brand,
                  item_category: (typeof removeFromCart_category !== "undefined") ? removeFromCart_category : "",
                  item_category2: (typeof removeFromCart_category2 !== "undefined") ? removeFromCart_category2 : "",
                  item_category3: (typeof removeFromCart_category3 !== "undefined") ? removeFromCart_category3 : "",
                  item_category4: (typeof removeFromCart_category4 !== "undefined") ? removeFromCart_category4 : "",
                  item_category5: (typeof removeFromCart_category5 !== "undefined") ? removeFromCart_category5 : "",
                  item_list_id: "",
                  item_list_name: removeFromCart_list,
                  item_variant: removeFromCart_variant,
                  location_id: "",
                  price: parseFloat(removeFromCart_price),
                  quantity: removeFromCart_quantity
                }
              ]
            }
          },
        };

        // GA3 Data Layer Push
        TagManager.dataLayer(tagManagerArgs_removeFromCart_GA3);
        // GA4 Data Layer Push
        TagManager.dataLayer(tagManagerArgs_removeFromCart_GA4);
        break;
    }
  };
  resetOrderDetailsOnLoadGTM = () => {
    this.setState({checkout_gtm_fireonce: false});
  };
  currentPage = (e) => {
    if (e == "bag") {
      this.setState({currentPage: "bag page"});
    } else if (e == "order-details") {
      this.setState({currentPage: "your bag"});
    } else {
      this.setState({currentPage: ""});
    }
  };
  signInModal = () => {
    this.setState({isSigninModalOpen: "isOpen"});
  };
  closeSigninModal = () => {
    this.setState({isSigninModalOpen: ""});
  };
  pageOnKeyUp = (e) => {
    if (e.which == 9) {
      // if TAB KEY was pressed
      this.setState({accessibilityInput: "isKeyboard"});
    }
    if (e.which == 27) {
      // if ESC KEY was pressed
      this.setState({isRemoveModalOpen: ""});
    }
  };
  pageOnMouseDown = () => {
    this.setState({accessibilityInput: "isMouse"});
  };
  cameFromBagPage = () =>{
    this.setState({cameFromBagPage: true});
  }
  render() {
    return (
      <div onKeyUp={(e) => this.pageOnKeyUp(e)} onClick={this.pageOnMouseDown}>
        <Styled.BodyStyle
          className={this.state.accessibilityInput}>
          <GlobalNav deleteItem={this.deleteItemHandler} isRemoveModalOpen={this.showConfirmModalHandler} closeConfirmModal={this.closeConfirmModalHandler} />
          <Router>
            <Switch>
              <Route
                exact
                path="/"
                render={() => {
                  return <Redirect to={this.state.bagPagePath} />;
                }}
              />
              <Route
                path={this.state.bagPagePath}
                exact
                render={() =>
                  this.state.profileError && this.state.profileError !== null && this.state.profileError !== "" ? (
                    <CheckoutPageError pageErrorCode="" pageErrorMessage={this.state.profileError} refreshPage={this.refreshPage} />
                  ) : (
                    <Bag
                      headerTitle="Bag"
                      itemCount={this.state.BagItemCount}
                      data={this.state}
                      changed={this.changeQuantityHandler}
                      deleteItem={this.deleteItemHandler}
                      isRemoveModalOpen={this.showConfirmModalHandler}
                      closeConfirmModal={this.closeConfirmModalHandler}
                      getBagAPI={this.getBagAPI}
                      resetOrderDetailsOnLoadGTM={this.resetOrderDetailsOnLoadGTM}
                      refreshPage={this.refreshPage}
                      bagDeleteModalRef={this.bagDeleteModalRef}
                      currentPage={(e) => this.currentPage(e)}
                      signInModal={this.signInModal}
                      closeSigninModal={this.closeSigninModal}
                      cameFromBagPage={() => this.cameFromBagPage()}
                    />
                  )
                }
              />
              <Route
                path={this.state.checkoutPagePath}
                exact
                render={() => (
                  <Confirm
                    headerTitle="Checkout"
                    bagCurrency={this.state.currency}
                    data={this.state}
                    isUserRegistered={this.state.isUserRegistered}
                    itemCount={this.state.BagItemCount}
                    changed={this.changeQuantityHandler}
                    deleteItem={this.deleteItemHandler}
                    isRemoveModalOpen={this.showConfirmModalHandler}
                    closeConfirmModal={this.closeConfirmModalHandler}
                    deliveryTabToggle={this.deliveryTabToggleHandler}
                    shippingTabToggle={this.shippingTabToggleHandler}
                    paymentTabToggle={this.paymentTabToggleHandler}
                    removeFocus={this.removeFocusHandler}
                    saveAsSelectedAddress={this.saveAsSelectedAddressHandler}
                    bagCount={this.state.cart.length}
                    getBagAPI={this.getBagAPI}
                    confirmItemsEmpty={this.confirmItemsEmpty}
                    guestCustomerId={this.guestCustomerId}
                    refreshPage={this.refreshPage}
                    getProfileAPI={this.getProfileAPI}
                    isGuestCheckoutBlank={this.isGuestCheckoutBlank}
                    currentPage={(e) => this.currentPage(e)}
                  />
                )}
              />
              <Route
                path={this.state.thankyouPagePath}
                exact
                render={() => (
                  <ThankYou headerTitle="Confirmation" data={this.state} refreshPage={this.refreshPage} isGuestCheckoutBlank={this.isGuestCheckoutBlank} />
                )}
              />
              <Route
                exact
                path="/*"
                render={() => {
                  return <PageDoesntExist data={this.state} />;
                }}
              />
            </Switch>
          </Router>
        </Styled.BodyStyle>
        <GlobalFooter />
      </div>
    );
  }
}

export default App;
